import bodybuilder from 'bodybuilder'
import * as Elasticsearch from '../../elasticsearch'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export type FetchRunDetailsAction = Request.RequestAction
export type FetchRunDetails =
  (communityIdentifier: string, communitySystemId: Types.CommunitySystemId) => FetchRunDetailsAction

export const fetchRunDetails: FetchRunDetails = (community, communitySystemId) =>
Elasticsearch.createEsSearch(Constants.FETCH_RUN_DETAILS)(
  community,
  Elasticsearch.Indexes.IntegrationRuns,
  bodybuilder()
    .query('match', Elasticsearch.DocumentFieldNames.Community, community)
    .query('match', Elasticsearch.DocumentFieldNames.CommunitySystemId, communitySystemId)
    .build(),
)



// WEBPACK FOOTER //
// ./src/pages/integration-reports/actions.ts